import {ReviewThread} from '@github-ui/diff-lines/review-thread'
import {StaticUnifiedDiffPreview} from '@github-ui/diff-lines/static-unified-diff-preview'
import type {Thread} from '@github-ui/diff-lines/conversation-types'
import type {FileKey, LineKey} from '@github-ui/diff-lines/types'
import {ThreadReplyComposer} from '../../../toolbar/comments-panel/ThreadReplyComposer'
import {CommentActionFileStats} from './CommentActionFileStats'
import type {DiffStats} from './comment-action-types'

type CommentActionExpandedProps = {
  filePath: string | undefined
  lineKey: LineKey | FileKey
  diffStats: DiffStats
  thread: Thread
  startReplyExpanded?: boolean
  onReplied?: () => void
}

export const CommentActionExpanded = ({
  filePath,
  lineKey,
  diffStats,
  thread,
  startReplyExpanded = false,
  onReplied,
}: CommentActionExpandedProps) => (
  <div className="d-flex flex-column">
    <CommentActionFileStats filePath={filePath} diffStats={diffStats} />
    <StaticUnifiedDiffPreview className="m-0 border-0" diffLines={thread.subject?.diffLines} tabSize={4} />
    <ReviewThread
      lineMarkersKey={lineKey}
      batchingEnabled
      commentAnchorPrefix={'panel-r'}
      disableSuggestedChangesActions
      filePath={filePath ?? ''}
      gridCellId={`${thread.id}-comments-panel-thread`}
      isInlineComment={false}
      // ugh why did I make this hack
      thread={{...thread, viewerCanReply: false}}
      shouldLimitHeight={false}
      startExpanded={startReplyExpanded}
    />
    {thread.viewerCanReply && (
      <ThreadReplyComposer thread={thread} startExpanded={startReplyExpanded} onCompleted={onReplied} />
    )}
  </div>
)
